// Generated file, do not edit.

import { type Rules } from "../ast.ts";

export default {
  start: "TODO Not implemented yet",
} as Rules;
